// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__1qBgq","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__2xmjG"};